import React from 'react'
import { cn } from '@/lib/utils'

export const StarRating: React.FC<{
	rating: number | null
	size?: 'small' | 'medium' | 'large'
	className?: string
}> = ({ rating, size = 'medium', className = '' }) => {
	if (rating === null || rating < 0 || rating > 5) {
		return null
	}

	const sizeClasses = {
		small: 'w-3 h-3',
		medium: 'w-5 h-5',
		large: 'w-6 h-6',
	}

	const starClass = sizeClasses[size]
	const stars = Array.from({ length: 5 }, (_, i) => {
		return i < rating ? 'full' : 'empty'
	})

	return (
		<div className={cn('flex', className)}>
			{stars.map((type, index) => (
				<span key={index} className="inline-block mr-0.5">
					<svg
						className={cn(
							starClass,
							type === 'empty'
								? 'text-gray-300 dark:text-gray-600'
								: 'text-amber-400'
						)}
						fill="currentColor"
						viewBox="0 0 20 20">
						<path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
					</svg>
				</span>
			))}
		</div>
	)
}
